import { Component, OnInit } from '@angular/core';
import { AuthenticationService, MessageQueService } from '../../services/index';
import { Params } from '../../models/index';
import { Codes } from '../../models/index';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import PopupHelper from '../../models/popupHelper';
import { AlertResult } from '../../models/alertifyPromise';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: 'forgotPassword.component.html',
  styleUrls: ['forgotPassword.component.scss'],
  providers: [MessageQueService]
})

export class ForgotPasswordComponent implements OnInit {
  retrievePasswordForm: FormGroup;
  show: boolean;

  constructor(private formBuilder: FormBuilder, private msgSvc: MessageQueService, private authenticationService: AuthenticationService) {
    this.show = false;
  }

  ngOnInit() {
    this.msgSvc.setControlKey();
    this.retrievePasswordForm = this.formBuilder.group({
      retrieve: this.formBuilder.group({
        userName: ['', Validators.compose([
          Validators.required,
          Validators.maxLength(30),
          Validators.minLength(4)])
        ],
        email: ['', Validators.compose([
          Validators.required,
          Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}'),
          Validators.maxLength(100)])
        ],
      })
    });
  }
  requestPassword() {
    const form = this.retrievePasswordForm.value;
    const retrieve: Params = Object.assign({}, form.retrieve, { confirmPassword: undefined });

    this.authenticationService.resetPassword(retrieve.userName, retrieve.email)
      .subscribe((codes: Codes[]) => {
        const code = codes.find((rc: Codes) => rc === Codes.ok);
        if (code === Codes.ok) {
          if (this.authenticationService.isStatusInvalid === 400 ) {
            const message = 'Email message not sent.  Please try again.';
            this.forgotPasswordRequest(message, 'error');
          } else if (this.authenticationService.isStatusInvalid === 200) {
            const message = 'Email sent, to provided email address, with additional instructions';
            this.forgotPasswordRequest(message, 'success');
          } else if (this.authenticationService.isStatusInvalid === 401) {
            const message = 'Invalid user and/or password.  Please try again.  Access denied';
            this.forgotPasswordRequest(message, 'error');
          }
        } else {
          for (const errorCode of codes) {
            switch (errorCode) {
              case Codes.requireUsername:
                this.setValidationErrorByControlName('retrieve.userName', 'required');
                break;
              case Codes.requiredEmail:
                this.setValidationErrorByControlName('retrieve.email', 'required');
                break;
              default:
                break;
            }
          }
        }
      });
  }
  private setValidationErrorByControlName(controlName: string, validatorType: string) {
    const control = this.retrievePasswordForm.get(controlName);
    const validator = {};
    validator[validatorType] = true;
    control.setErrors(validator);
    control.markAsTouched();
  }
  setBlurById(id: string) {
    const classListPasswordSidebar = document.getElementById(id).classList;
    classListPasswordSidebar.remove('show-sidebar');
    classListPasswordSidebar.add('hide-sidebar');
  }

  setFocusById(id: string) {
    const classListPasswordSidebar = document.getElementById(id).classList;
    classListPasswordSidebar.remove('hide-sidebar');
    classListPasswordSidebar.add('show-sidebar');
  }
  home() {
    this.show = false;
    this.retrievePasswordForm.reset();
  }

  forgotPassword(isVisible: boolean) {
    this.show = isVisible;
  }
  showForgotPassword(): boolean {
    if (this.show) {
      return true;
    } else {
      return false;
    }
  }
  async forgotPasswordRequest(message, type) {
    const alertResult = await PopupHelper.userHelper(message, type);
    if (alertResult === AlertResult.Ok) {
      if (type === 'error') {
         this.retrievePasswordForm.reset();
      } else {
            this.home();
      }
    }
  }

  get userName() { return this.retrievePasswordForm.get('retrieve.userName'); }
  get email() { return this.retrievePasswordForm.get('retrieve.email'); }
}




// WEBPACK FOOTER //
// ./src/app/forgotPassword/forgotPassword.component.ts